import { StateUtils } from '@spartacus/core';

export const TICKETS_FEATURE = 'tickets';
export const TICKETS = '[Tickets] Tickets';

export interface StateWithTickets {
  [TICKETS_FEATURE]: CustomTicketsListState;
}

export interface CustomTicketsListState {
  entities: StateUtils.LoaderState<any>;
}
